import React from 'react';
import './About.css';

class About extends React.Component {
  render() {
    return (
      <div className="About">
        <h3>О нас</h3>
        <div className="block">
          <p>Конвертер валют — опция, которая помогает мгновенно подсчитать сумму обмена нужной вам валюты на евро. Состоятельные люди пользуются функционалом, когда оценивают стоимость своих сбережений в иностранных денежных знаках.</p>
          <h3>Чем калькулятор может быть полезен?</h3>
          <p>Покупатели легко ориентируются в ассортименте зарубежного магазина, если представляют стоимость товара. Организации прибегают к валютному калькулятору, когда вынуждены пересчитывать цену продукции из-за подорожания импортных запчастей. Компании интересуются денежным курсом, если возникает потребность отправить сотрудника за границу.</p>

          <h3>Применение</h3>
          <p>Это очень удобное средство для выполнения ваших потребностей не тратя время на пересчеты, мы это сделаем за вас.
          От вас требуется всего лишь выбрать нужную вам валюту, сумму и нажать по кнопке пересчета, мгновенно вам придет результат работы калькулятора</p>
        </div>
      </div>
    );
  }
}

export default About;
